import { mergeClassnames } from '@heathmont/moon-core-tw';

type Props = {
  className: string;
};

const ItemText: FC<Props> = ({ children, className }) => (
  <p className={mergeClassnames('text-moon-16 text-bulma', className)}>
    {children}
  </p>
);

export default ItemText;
